import { usePersona } from './usePersona';

export const useGetAccountProfileLink = (
  accountId: string,
  tab = DEFAULT_TAB
) => {
  const persona = usePersona();

  if (persona.isAgency) {
    return `${persona.basePath}/accounts/details/${accountId}/${tab}`;
  }

  return `${persona.basePath}/account/${accountId}/${tab}`;
};

const DEFAULT_TAB = 'account-profile';
